import { callAjax } from '../helpers'

class Newsletter {
  private form: HTMLFormElement

  constructor(form: HTMLFormElement) {
    this.form = form

    this.init()
  }

  private init() {
    const { form } = this

    form.addEventListener('wpcf7mailsent', e => {
      e.preventDefault()
      const formData = new FormData(form)
      formData.append('action', 'ajaxSubscribeToNewsletter')

      return callAjax({
        method: 'POST',
        body: formData,
      })
        .then(res => res.json())
        .then(res => {
          console.log(res)
        })
    })
  }
}

export default Newsletter
